import { applyAdminQaImport, previewAdminQaImport } from '@/lib/api/admin';
import ItemsImportDialog from '@/components/knowledge-base/items-import-dialog';

const QA_IMPORT_COPY = {
  description:
    'The server parses the file, computes a diff against the live phrases, and only applies the changes once you confirm.',
  xlsxHint: 'Start from Export → Excel workbook: one sheet per category, and rows with an empty ID get one on import.',
  mdHint: 'Accepts the same `### sourceId` markdown format used by the Knowledge Base editor.',
  itemNouns: ['phrase', 'phrases'],
  fields: {
    section: 'Category',
    question: 'Trigger',
    aliases: 'Alt triggers',
    answer: 'Reply',
    lockAfterAnswer: 'Locks after reply',
  },
};

function QaImportDialog(props) {
  return (
    <ItemsImportDialog
      {...props}
      previewImport={previewAdminQaImport}
      applyImport={applyAdminQaImport}
      copy={QA_IMPORT_COPY}
    />
  );
}

export default QaImportDialog;
